const moment = require("moment");
import { defaultGetOptions, defaultPutOptions, handle } from "../../../custom_api/api_utils";
export const managementApi = ()=>{
    const baseUrl = "/api/v1/management";
    return {
        fetchUnknownReactions: async ()=>{
            const res = await fetch(`${baseUrl}/blogPost/comments`, {
                method: "GET",
                ...defaultGetOptions()
            });
            const reactions = await handle(res);
            return reactions.kind === 'result' ? {
                ...reactions,
                value: reactions.value.map((i)=>({
                        ...i,
                        created: moment(i.created),
                        createdDate: moment(i.createdDate),
                        updated: moment(i.updated)
                    }))
            } : reactions;
        },
        fetchBlogPosts: async ()=>{
            const res = await fetch(`${baseUrl}/blogPost/all`, {
                method: "GET",
                ...defaultGetOptions()
            });
            const temp = await handle(res);
            if (temp.kind != 'result') return temp;
            return {
                ...temp,
                value: temp.value
            };
        },
        updateStatus: async (id, status)=>{
            const body = {
                id: id,
                status: status
            };
            const res = await fetch(`${baseUrl}/blogPost/comments`, {
                body: JSON.stringify(body),
                method: "PUT",
                ...defaultPutOptions()
            });
            if (400 <= res.status && res.status < 500) return {
                kind: 'unauthorized',
                status: res.status
            };
            if (res.status >= 500) return {
                kind: 'failed',
                status: res.status
            };
            return {
                kind: 'result',
                status: 200,
                value: {}
            };
        },
        acceptAll: async (ids)=>{
            const body = ids.map((x)=>{
                return {
                    id: x,
                    status: "accepted"
                };
            });
            const res = await fetch(`${baseUrl}/blogPost/comments/bulk`, {
                body: JSON.stringify(body),
                method: "PUT",
                ...defaultPutOptions()
            });
            if (400 <= res.status && res.status < 500) return {
                kind: 'unauthorized',
                status: res.status
            };
            if (res.status >= 500) return {
                kind: 'failed',
                status: res.status
            };
            return {
                kind: 'result',
                status: 200,
                value: {}
            };
        }
    };
};
